import React from 'react'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles((theme) => ({
    btn: {
        backgroundColor: '#28A504',
        fontWeight: '700'
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: 'transparent !important',
        border: 'none !important',
        boxShadow: 'none'
    },
    noBg: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
    },
}));

const TopCats = ({ categories, loading, lang }) => {

    const classes = useStyles()

    return (
        <>
            {(!loading && typeof categories !== "undefined") && (

                <Grid container spacing={2}>

                    <Grid item md={6} xs={12} className={`rightBox`}>
                        <Paper item evelation={0} className={classes.noBg}>
                            <Box evelation={0}>
                                {categories.slice(0, 3).map(category => (

                                    <div className="home-page-cat-box" style={{ backgroundImage: `url(${category.imgURL})` }}>
                                        <Link to={`/products/page/1/${category.id}`}>
                                            <h3>{category.title}</h3>
                                        </Link>
                                    </div>

                                ))}
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item md={6} xs={12} className={`leftBox`}>
                        <Paper item evelation={0} className={classes.noBg}>
                            <Box evelation={0}>
                                {categories.slice(3, 7).map(category => (

                                    <div className="home-page-cat-box" style={{ backgroundImage: `url(${category.imgURL})` }}>
                                        <Link to={`/products/page/1/${category.id}`}>
                                            <h3>{category.title}</h3>
                                        </Link>
                                    </div>

                                ))}
                            </Box>

                        </Paper>
                    </Grid>

                </Grid>

            )}
        </>
    )
}
export default TopCats
